import React from 'react';
import { RefreshCw } from 'lucide-react';

export const Header = ({ user, refreshData }) => {
  const handleRefresh = () => {
    if (refreshData) {
      refreshData();
    }
  };
  return (
    <div className="flex justify-between items-center mb-8">
      <div>
        <h1 className="text-2xl font-semibold">Willkommen zurück, {user?.name || 'User'}</h1>
        <p className="text-gray-500">Aktuelle Emissionswerte aller Projekte</p>
      </div>
      <div className="flex items-center space-x-4">
        <button
          className="p-2 hover:bg-gray-100 rounded-full flex items-center gap-1 text-green-600"
          onClick={handleRefresh}
          title="Daten aktualisieren"
        >
          <RefreshCw className="h-5 w-5" />
          <span className="text-sm">Aktualisieren</span>
        </button>
        <div className="flex items-center space-x-2">
          <img
            src={user?.avatar || '/api/placeholder/32/32'}
            alt="Profile"
            className="h-8 w-8 rounded-full"
          />
          <span className="text-gray-700">{user?.name || 'User'}</span>
        </div>
      </div>
    </div>
  );
};